import { FC, PropsWithChildren } from "react";
import styles from "../Scam.module.scss";
import { Link } from "react-router-dom";

const Content: FC<PropsWithChildren> = ({ children }) => {
    return (
        <section className={styles.scam + " w-full"}>
            {/* <div className={styles.header}>
                <h1 className={styles.headline}>Checker Scam</h1>
                <div className={styles.breadcrumb}>
                    <img width={16} height={16} src="/images/swap/home.svg" alt="" />
                    <img style={{ opacity: 0.5 }} width={12} height={12} src="/images/swap/right.svg" alt="" />
                    <Link to={"/scam"}>CHECKER SCAM</Link>
                </div>
            </div> */}
            <div className={styles.content}>{children}</div>
        </section>
    );
};

export default Content;
